import { useTheme } from 'styled-components'
import { SearchBarSlice } from './SearchBarSlice'
import { SearchBarDefault } from './SearchBarDefault'

export const SearchBar = () => {
  const theme = useTheme()

  return theme.template === 'template-4' ? (
    <SearchBarSlice />
  ) : (
    <SearchBarDefault />
  )
}
